import { createScriptTag } from '@/third-party/helpers'

export const importVwo = (document: Document): void => {
    createScriptTag(document, '/assets-new/vwo-v1.js', 'vwoCode')
}
